var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDriveUp = function SvgDriveUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22809_7301)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.3822 8.7575C14.2267 8.315 13.7911 8 13.2778 8H4.72222C4.20889 8 3.78111 8.315 3.61778 8.7575L2 13.25V19.25C2 19.6625 2.35 20 2.77778 20H3.55556C3.98333 20 4.33333 19.6625 4.33333 19.25V18.5H13.6667V19.25C13.6667 19.6625 14.0167 20 14.4444 20H15.2222C15.65 20 16 19.6625 16 19.25V13.25L14.3822 8.7575ZM4.72222 16.25C4.07667 16.25 3.55556 15.7475 3.55556 15.125C3.55556 14.5025 4.07667 14 4.72222 14C5.36778 14 5.88889 14.5025 5.88889 15.125C5.88889 15.7475 5.36778 16.25 4.72222 16.25ZM13.2778 16.25C12.6322 16.25 12.1111 15.7475 12.1111 15.125C12.1111 14.5025 12.6322 14 13.2778 14C13.9233 14 14.4444 14.5025 14.4444 15.125C14.4444 15.7475 13.9233 16.25 13.2778 16.25ZM3.55556 12.5L4.72222 9.125H13.2778L14.4444 12.5H3.55556Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 8,
    width: 1,
    height: 12,
    rx: 0.5,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 2,
    width: 7,
    height: 8,
    rx: 1,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5462 4C20.0257 4 20.387 4.12172 20.6301 4.36517C20.8767 4.60487 21 4.9382 21 5.36517C21 5.79213 20.8767 6.12734 20.6301 6.37079C20.387 6.61423 20.0257 6.73595 19.5462 6.73595H19.0274V8H18V4H19.5462ZM19.0274 5.85393H19.4024C19.762 5.85393 19.9418 5.69101 19.9418 5.36517C19.9418 5.04307 19.762 4.88202 19.4024 4.88202H19.0274V5.85393Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22809_7301"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
export default SvgDriveUp;